import { render, staticRenderFns } from "./VirtualExamine.vue?vue&type=template&id=275b9261&scoped=true&"
import script from "./VirtualExamine.vue?vue&type=script&lang=js&"
export * from "./VirtualExamine.vue?vue&type=script&lang=js&"
import style0 from "./VirtualExamine.vue?vue&type=style&index=0&id=275b9261&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275b9261",
  null
  
)

export default component.exports